const states = {
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  FM: 'Federated States Of Micronesia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MH: 'Marshall Islands',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  MP: 'Northern Mariana Islands',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PW: 'Palau',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Islands',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const stateFIPS = {
  AK: '02',
  AL: '01',
  AR: '05',
  AS: '60',
  AZ: '04',
  CA: '06',
  CO: '08',
  CT: '09',
  DC: '11',
  DE: '10',
  FL: '12',
  GA: '13',
  GU: '66',
  HI: '15',
  IA: '19',
  ID: '16',
  IL: '17',
  IN: '18',
  KS: '20',
  KY: '21',
  LA: '22',
  MA: '25',
  MD: '24',
  ME: '23',
  MI: '26',
  MN: '27',
  MO: '29',
  MS: '28',
  MT: '30',
  NC: '37',
  ND: '38',
  NE: '31',
  NH: '33',
  NJ: '34',
  NM: '35',
  NV: '32',
  NY: '36',
  OH: '39',
  OK: '40',
  OR: '41',
  PA: '42',
  PR: '72',
  RI: '44',
  SC: '45',
  SD: '46',
  TN: '47',
  TX: '48',
  UT: '49',
  VA: '51',
  VI: '78',
  VT: '50',
  WA: '53',
  WI: '55',
  WV: '54',
  WY: '56',
};

export default states;
